<template>
  <div class="plan-add">
    <BaseFrame
     :btns="[
      {
        name: 'cancel',
        text: '取消'
      },
      {
        name: 'reset',
        text: '重置'
      },
      {
        name: 'save',
        text: '保存'
      },
      {
        name: 'submit',
        text: '提交',
        type: 'primary'
      },
     ]"
     :breadcrumb="[
      {
        name: 'plan',
        title: '采购计划列表'
      },
      {
        name: 'planAdd',
        title: '新增采购计划'
      }
     ]"
     @btn-click="onBtnClick"
     :loadZIndex = true
      >
      <div slot="ctrls">
        <lk-checkbox
          class="isScan"
          v-model="isScan"
          :true-value="1"
          :false-value="2"
          @on-change="handleChangeScan">扫码添加商品
        </lk-checkbox>
      </div>
      <div slot="content">
        <lk-card title="采购信息">
          <lk-form :label-width='134' label-position="right"
            :model='purchasePlan'
            :rules="planValidate">
            <lk-row>
              <lk-col span='7'>
                <lk-form-item label='商品类型:' prop='goodsType'>
                  <lk-select v-model='purchasePlan.goodsType' @on-change="onGoodsTypeChange" >
                    <lk-option v-for="item in getNormalGoodsTypes" :key="item.value" :value="item.value">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span='7'>
                <lk-form-item label='来源:' prop='type'>
                  <lk-select v-model='purchasePlan.type' :disabled="purchasePlan.goodsType === 3" @on-change="onGoodsOriginChange">
                    <lk-option v-for="item in getGoodsOrigin" :key="item.value" :value="item.value">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span='10' v-if="expressStatus">
                <lk-form-item label='物流类型:'>
                  <lk-radio-group v-model='purchasePlan.expressType'>
                    <lk-radio v-for='item in expressTypeList1' :key='item.id' :label='item.id'>
                      <span>{{item.name}}</span>
                    </lk-radio>
                  </lk-radio-group>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row>
              <lk-col span='7'>
                <lk-form-item label='采购形式:' prop='procurementForm'>
                  <lk-select v-model='purchasePlan.procurementForm'>
                    <lk-option v-for="item in procurementFormList" :key="item.id" :value="item.id">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span='7'>
                <lk-form-item label='审批单附件:' prop=''>
                  <Attachment
                    :uploadInfo='uploadInfo'
                    @attachmentConfirm='attachmentConfirm'
                  ></Attachment>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
        <lk-card title="商品信息" class="goods-card">
          <div class="goods-add-wrap">
            <label class="goods-add-label">新增商品：</label>
            <PlanInputSearch
              class="mr8"
              ref="goods0"
              :goodsType="purchasePlan.goodsType"
              :selectedList="selectedIdList"
              :isScan="isScan"
              :purchaseType="purchasePlan.type"
              @selected="onInputSelected">
            </PlanInputSearch>
          </div>
          <div class="sum-wrap">
            <div class="title-amount">总商品数量</div>
            <div class="content-amount">{{goodsNum}}</div>
            <div class="title-money">总金额（元）</div>
            <div class="content-money">&yen;{{purchaseAmount}}</div>
          </div>
          <dtp-table
            border
            :columns="columns"
            :data="tableData"
            class="plan-table"
            no-data-text="数据为空"
          />
        </lk-card>
        <lk-card title="有效期过期商品" class="expir-card">
          <dtp-table border :columns="expirColumns" :data="expirTable" class="plan-table"/>
        </lk-card>
      </div>
    </BaseFrame>
    <DTPModal
      v-model="typeModelShow"
      :content='typeModalContent'
      @confirm='onTypeModelOk'
      @handleCancel='onTypeModelCancel'
    ></DTPModal>
    <DTPModal
      v-model="resetModelShow"
      content='重置后将清空当前页面所有信息'
      @confirm='onResetModelOk'
    ></DTPModal>
  </div>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import hotkeys from 'hotkeys-js';
import BaseFrame from '../../components/frame/NewBaseFrame';
import purchase from '../../services/purchase';
import DtpTable from '../../components/DtpTable';
import utils from '../../libs/utils';
import DtpInputNumber from '../../components/DtpInputNumber';
import DTPModal from '../../components/DTPModal.vue';
import PlanInputSearch from './PlanInputSearch.vue';
import Expire from '../../assets/expir.svg';
import SupplierListSelect from '../../components/SupplierListSelect.vue';
import Attachment from '../../components/purchase/Attachment';
import expressTypeList from '../../libs/sharedDara';


export default {
  name: 'purchasePlanAdd',
  components: {
    BaseFrame,
    DtpTable,
    DTPModal,
    Attachment,
    PlanInputSearch,
  },
  data() {
    const self = this;
    return {
      attachmentShow: false,
      uploadInfo: [
        {
          appendixName: '',
          appendixUrl: '',
        },
      ], // 审批单附件
      procurementFormList: [
        {
          id: 1,
          name: '日常采购',
        },
      ],
      limitedNumer: 100,
      getNormalGoodsTypes: [],
      expressTypeList1: [],
      expressStatus: true,
      isScan: 2,
      typeModelShow: false,
      resetModelShow: false,
      typeModalContent: '',
      planValidate: {
        goodsType: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'number',
          },
        ],
        type: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'number',
          },
        ],
        procurementForm: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'number',
          },
        ],
      },
      purchasePlan: {
        goodsType: 1,
        type: 1,
        expressType: null,
        procurementForm: 1,
      },
      backGoodsType: 1,
      backOriginType: 1,
      columns: [
        {
          title: '行号',
          minWidth: 60,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '通用名称',
          minWidth: 142,
          tooltip: true,
          key: 'approvedDrugName',
          render: (h, params) => {
            const hasExpiryLicense = params.row.hasExpiryLicense;
            const resStr = params.row.approvedDrugName;
            let isExpir = false;
            let resDiv;
            const expirIcon = h('img', {
              class: 'expir-icon',
              attrs: {
                src: Expire,
              },
            });
            if (hasExpiryLicense == 1) {
              isExpir = true;
            }

            if (isExpir) {
              resDiv = [expirIcon, resStr];
            } else {
              resDiv = resStr;
            }
            return h('div', {
              class: {
                'approve-goods-wrap': true,
              },

            }, resDiv);
          },
        },
        {
          title: '规格',
          minWidth: 130,
          tooltip: true,
          key: 'specification',
        },
        {
          title: '生产企业',
          minWidth: 142,
          tooltip: true,
          key: 'manufacturer',
        },
        {
          title: '上市许可持有人',
          minWidth: 142,
          tooltip: true,
          key: 'mah',
        },
        {
          title: '仓库库存',
          minWidth: 82,
          tooltip: true,
          key: 'inventoryNum',
        },
        {
          title: '上月销量',
          minWidth: 82,
          tooltip: true,
          key: 'lastMonthSaleNum',
        },
        {
          title: '在途数量',
          minWidth: 82,
          tooltip: true,
          key: 'onTheWayNum',
        },
        {
          title: '商品编码',
          minWidth: 82,
          tooltip: true,
          key: 'drugSerialCode',
        },
        {
          title: '商品名',
          minWidth: 142,
          tooltip: true,
          key: 'goodsName',
        },
        {
          title: '批准文号',
          minWidth: 116,
          tooltip: true,
          key: 'approvalNumber',
        },
        {
          title: '剂型',
          minWidth: 116,
          tooltip: true,
          key: 'dosageForm',
        },
        {
          title: '产地',
          minWidth: 142,
          tooltip: true,
          key: 'countryOfOrigin',
        },
        {
          title: '医保编码',
          width: 200,
          tooltip: true,
          key: 'medicalSerialCode',
        },
        {
          title: '计划数量',
          minWidth: 90,
          fixed: 'right',
          render: (h, params) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.onMountInput(params.index, value);
              },
            },
            props: {
              value: params.row.num,
              min: 0,
              precision: 2,
              ifNeedCheckAllNumber: true,
              frontDecimal: 7,
            },
          }),
        },
        {
          title: '计划单价',
          minWidth: 112,
          fixed: 'right',
          render: (h, params) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.onPriceInput(params.index, value);
              },
            },
            props: {
              value: params.row.planPrice,
              min: 0,
              precision: 6,
              maxlength: 12,
              ifNeedCheckAllNumber: true,
              frontDecimal: 5,
            },
          }),
        },
        {
          title: '供应商',
          fixed: 'right',
          minWidth: 172,
          render: (h, params) => h(SupplierListSelect, {
            props: {
              value: params.row.supplierId,
              status: 1,
              purchaseType: this.purchasePlan.type,
            },
            on: {
              'on-change': (value, selectedItem) => {
                this.onChangeSupplier(params.index, value, selectedItem);
              },
            },
          }),
        },
        {
          title: '款期',
          fixed: 'right',
          minWidth: 100,
          render: (h, params) => {
            const optionArr = [
              h('option', {
                domProps: {
                  value: 1,
                },
              }, '预付'),
              h('option', {
                domProps: {
                  value: 2,
                },
              }, '现款'),
              h('option', {
                domProps: {
                  value: 3,
                },
              }, '7天'),
              h('option', {
                domProps: {
                  value: 4,
                },
              }, '15天'),
              h('option', {
                domProps: {
                  value: 5,
                },
              }, '30天'),
              h('option', {
                domProps: {
                  value: 6,
                },
              }, '45天'),
              h('option', {
                domProps: {
                  value: 7,
                },
              }, '60天'),
              h('option', {
                domProps: {
                  value: 8,
                },
              }, '90天'),
              h('option', {
                domProps: {
                  value: 9,
                },
              }, '压批'),
              h('option', {
                domProps: {
                  value: 10,
                },
              }, '实销实结'),
            ];
            return h('select',
              {
                class: {
                  'dtp-select': true,
                },
                domProps: {
                  value: params.row.paymentPeriod,
                },
                on: {
                  change: (e) => {
                    self.tableData[params.index].paymentPeriod = e.target.value;
                  },
                },
              }, optionArr);
          },
        },
        {
          title: '成本类型',
          fixed: 'right',
          minWidth: 90,
          render: (h, params) => {
            const optionArr = [
              h('option', {
                domProps: {
                  value: 1,
                },
              }, '普通'),
              h('option', {
                domProps: {
                  value: 2,
                },
              }, '寄售'),
            ];
            return h('select',
              {
                class: {
                  'dtp-select': true,
                },
                domProps: {
                  value: params.row.payment,
                },
                on: {
                  change: (e) => {
                    self.tableData[params.index].payment = e.target.value;
                  },
                },
              }, optionArr);
          },
        },
        {
          title: '操作',
          fixed: 'right',
          width: 72,
          render: (h, params) => h('lk-button',
            {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.onDelete(params.index);
                },
              },

            }, '删除'),
        },
      ],
      expirColumns: [
        {
          title: '通用名称',
          minWidth: 116,
          key: 'approvedDrugName',
        },
        {
          title: '药品注册批件',
          minWidth: 116,
          key: 'drugRegApprovalExpiry',
          render: (h, params) => {
            const drugRegApprovalExpiry = params.row.drugRegApprovalExpiry;
            let resStr = '-';
            let isExpir = false;
            if (drugRegApprovalExpiry) {
              resStr = utils.formatTime(drugRegApprovalExpiry, 'YYYY/MM/DD');
            }
            if (params.row.isDrugRegApprovalExpiry == 1) {
              isExpir = true;
            }
            return h('span', {
              class: {
                'orange-words': isExpir,
              },
            }, resStr);
          },
        },
        {
          title: '进口注册证',
          minWidth: 116,
          key: 'importRegCertExpiry',
          render: (h, params) => {
            const importRegCertExpiry = params.row.importRegCertExpiry;
            let resStr = '-';
            let isExpir = false;
            if (importRegCertExpiry) {
              resStr = utils.formatTime(importRegCertExpiry, 'YYYY/MM/DD');
            }
            if (params.row.isImportRegCertExpiry == 1) {
              isExpir = true;
            }
            return h('span', {
              class: {
                'orange-words': isExpir,
              },
            }, resStr);
          },
        },
        {
          title: '生产许可证',
          minWidth: 116,
          key: 'prodLicenseExpiry',
          render: (h, params) => {
            const prodLicenseExpiry = params.row.prodLicenseExpiry;
            let resStr = '-';
            let isExpir = false;
            if (prodLicenseExpiry) {
              resStr = utils.formatTime(prodLicenseExpiry, 'YYYY/MM/DD');
            }
            if (params.row.isProdLicenseExpiry == 1) {
              isExpir = true;
            }
            return h('span', {
              class: {
                'orange-words': isExpir,
              },
            }, resStr);
          },
        },
        {
          title: '备注',
          minWidth: 116,
          key: 'expiryRemark',
          render: (h, params) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.onExpiryRemarkBlur(e, params.row);
              },
            },
            props: {
              value: params.row.expiryRemark,
              maxlength: 100,
            },
          }),
        },
      ],
      tableData: [],
    };
  },
  watch: {
    tableData: {
      handler() {
        this.handleInputRegister();
        this.$store.commit('setLeaveModal', true);
      },
      deep: true,
    },
    'purchasePlan.goodsType': {
      handler() {
        // 切换文案
        if (this.purchasePlan.goodsType === 2) {
          this.purchasePlan.expressType = null;
          this.columns.splice(10, 1, {
            title: '注册证号/备案号',
            minWidth: 124,
            tooltip: true,
            key: 'approvalNumber',
          });
          this.expressStatus = false;
        } else if (this.purchasePlan.goodsType === 1) {
          this.expressStatus = true;
        } else {
          this.expressStatus = false;
          this.purchasePlan.expressType = null;
          this.columns.splice(10, 1, {
            title: '批准文号',
            minWidth: 116,
            tooltip: true,
            key: 'approvalNumber',
          });
        }
      },
    },
  },
  mounted() {
    this.purchasePlan.type = 1;
    this.expressTypeList1 = expressTypeList.expressTypeList;
    this.getNormalGoodsTypes = expressTypeList.getNormalGoodsTypes;
    this.hotkeysRegister();
  },
  computed: {
    selectedIdList() {
      return this.tableData.map(item => item.medicineId);
    },
    expirTable() {
      return this.tableData.filter(value => value.hasExpiryLicense == 1);
    },
    goodsNum() {
      let res = 0;
      this.tableData.forEach((item) => {
        res += item.num;
      });
      return res.toFixed(2);
    },
    purchaseAmount() {
      let res = 0;
      this.tableData.forEach((item) => {
        res += (item.num * item.planPrice);
      });
      return res.toFixed(2);
    },
    ...mapGetters(['getGoodsOrigin']),
  },
  methods: {
    attachmentConfirm(val) {
      this.uploadInfo = val;
    },
    hotkeysRegister() {
      hotkeys('alt+f1,option+fn+f1', () => {
        this.$refs.goods0.focus();
      });
    },
    handleInputRegister() {
      this.$nextTick(() => {
        const allInput = document.querySelectorAll('.ivu-table-cell:not(.ivu-table-hidden)  input:not([type=checkbox])');
        allInput.forEach((item, index) => {
          item.onkeydown = (e) => {
            if (e.key === 'Enter') {
              let nextIndex = index + 1;
              if (nextIndex >= allInput.length) {
                nextIndex = 0;
              }
              const nextEl = allInput[nextIndex];
              nextEl.focus();
            }
            if (e.altKey && e.key === 'F1') {
              this.$refs.goods0.focus();
            }
          };
        });
      });
    },
    onResetModelOk() {
      this.onReset();
      this.purchasePlan = {
        goodsType: 1,
        type: 1,
      };
      this.uploadInfo = [
        {
          appendixName: '',
          appendixUrl: '',
        },
      ];
      this.resetModelShow = false;
    },
    onTypeModelOk() {
      this.tableData = [];
      this.typeModelShow = false;
      this.setBack();
      this.closeLeavelModal();
    },
    onTypeModelCancel() {
      this.useBack();
    },
    onGoodsTypeChange() {
      console.log('onGoodsTypeChange');
      this.showTypeModal('GoodsType');
      // 如果是中药饮片，那么来源只能是普通商品
      if (this.purchasePlan.goodsType === 3) {
        this.purchasePlan.type = 1;
      }
      // 如果没有显示弹窗，直接更新
      if (!this.typeModelShow) {
        this.setBack();
      }
    },
    onGoodsOriginChange() {
      console.log('onGoodsOriginChange');
      this.showTypeModal('GoodsOrigin');
      // 如果没有显示弹窗，直接更新
      if (!this.typeModelShow) {
        this.setBack();
      }
    },
    setBack() {
      this.backGoodsType = this.purchasePlan.goodsType;
      this.backOriginType = this.purchasePlan.type;
    },
    useBack() {
      this.purchasePlan.goodsType = this.backGoodsType;
      this.purchasePlan.type = this.backOriginType;
    },
    showTypeModal(flag) {
      // 如果有商品，弹出弹窗
      if (flag === 'GoodsType') {
        this.typeModalContent = '采购类型一旦变更，将清空商品信息。是否确定变更？';
      } else {
        this.typeModalContent = '采购来源一旦变更，将清空商品信息。是否确定变更？';
      }
      if (this.tableData.length > 0) {
        this.typeModelShow = true;
      }
    },
    onExpiryRemarkBlur(e, row) {
      const expiryRemark = e.target.value;
      this.tableData.forEach((item) => {
        if (item.medicineId == row.medicineId) {
          item.expiryRemark = expiryRemark;
        }
      });
    },
    // eslint-disable-next-line func-names
    onBtnClick: _.throttle(function (name) {
      if (name === 'save') {
        this.onSave();
      } else if (name === 'cancel') {
        this.onCancel();
      } else if (name === 'reset') {
        this.onShowResetModal();
      } else if (name === 'submit') {
        this.onSubmit();
      }
    }, 3000),
    onShowResetModal() {
      this.resetModelShow = true;
    },
    onCancel() {
      this.tableData = [];
      this.closeLeavelModal().then(() => {
        this.$router.push({ name: 'plan' });
      });
    },
    closeLeavelModal() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          this.$store.commit('setLeaveModal', false);
          resolve();
        });
      });
    },
    onReset() {
      this.tableData = [];
      this.closeLeavelModal();
    },
    onSave() {
      this.onAdd('save');
    },
    onSubmit() {
      this.onAdd('submit');
    },
    onChangeSupplier(index, value, supplierObj) {
      const item = this.tableData[index];
      item.purchaseMedicineSupplierCode = supplierObj && supplierObj.code;
      item.purchaseMedicineSupplierName = supplierObj && supplierObj.name;
      item.purchaseMedicineSupplierId = value;
      item.supplierId = value;
    },
    onAdd(flag) {
      let addFunction;
      let noValidate = false;
      let noRemarkValidate = false;
      if (flag === 'save') {
        addFunction = purchase.planSave;
      } else {
        addFunction = purchase.planAddAndSubmit;
      }
      if (this.tableData.length <= 0) {
        this.$Message.warning('采购计划为空时无法保存或提交，请至少选择一个商品');
        return;
      }
      const medicineArr = this.tableData.map(item => ({
        purchaseMedicine: {
          medicineId: item.medicineId,
          payment: item.payment,
          planPrice: item.planPrice,
          num: item.num,
          supplierId: item.supplierId,
          supplierName: item.supplierName,
          supplierCode: item.supplierCode,
          drugSerialCode: item.drugSerialCode,
          approvedDrugName: item.approvedDrugNames,
          specification: item.specifications,
          dosageForm: item.dosageForm,
          drugMinimumPackagingUnit: item.drugMiniPackageUnit,
          countryOfOrigin: item.countryOfOrigin,
          manufacturer: item.manufacturer,
          storageCondition: item.storageConditions,
          expiryRemark: item.expiryRemark,
          hasExpiryLicense: item.hasExpiryLicense,
          paymentPeriod: item.paymentPeriod,
        },
      }));
      medicineArr.forEach((item) => {
        const purchaseMedicine = item.purchaseMedicine;
        if (flag !== 'save') {
        // 判断单价不为空
          if (purchaseMedicine.planPrice === null) {
            noValidate = true;
          }
          if (purchaseMedicine.paymentPeriod === null) {
            noValidate = true;
          }
          if (!purchaseMedicine.num || !purchaseMedicine.supplierId || !purchaseMedicine.payment) {
            noValidate = true;
          }
          if (!_.isNumber(purchaseMedicine.num) || !_.isNumber(purchaseMedicine.planPrice)) {
            noValidate = true;
          }
          if (purchaseMedicine.hasExpiryLicense == 1 && !purchaseMedicine.expiryRemark.trim()) {
            noRemarkValidate = true;
          }
        }
      });
      if (flag !== 'save' && (!this.purchasePlan.goodsType || !this.purchasePlan.type)) {
        noValidate = true;
      }
      if (noRemarkValidate) {
        this.$Message.error('存在有效期已过期商品，需要添加过期备注才可提交。');
        return;
      }
      if (noValidate) {
        // 验证不通过
        this.$Message.error('请填写完整数据');
        return;
      }

      const data = {
        purchaseMedicineInfoVoList: medicineArr,
        purchasePlan: this.purchasePlan,
        bizExtraVos: this.uploadInfo.some(item => item.appendixName === '' || item.appendixUrl === '') ? [{}] : this.uploadInfo,
      };
      addFunction(data).then((res) => {
        if (res.data.status === 200) {
          this.closeLeavelModal().then(() => {
            this.$router.push({ name: 'plan' });
          });
        } else {
          this.$Message.error(res.data.error);
        }
      });
    },
    onDelete(index) {
      this.tableData.splice(index, 1);
    },
    onMountInput(index, value) {
      const item = this.tableData[index];
      item.num = value;
    },
    onPriceInput(index, value) {
      const item = this.tableData[index];
      item.planPrice = value;
    },
    onInputSelected(item) {
      let isExist = false;
      this.tableData.forEach((tableItem) => {
        if (item.medicineId === tableItem.medicineId) {
          isExist = true;
        }
      });
      if (!isExist) {
        item.expiryRemark = '';
        if (this.purchasePlan.type === 2) {
          item.planPrice = 0;
        }
        if (this.tableData.length >= this.limitedNumer) {
          alert('单张单据不能超过100行明细，请拆分多次创建');
          return;
        }
        item.supplierId = null; // 禁止自动带出供应商
        item.paymentPeriod = null; // 禁止带出款期默认值，每次都需要重新选择，防止选错提交
        this.tableData.unshift(item);
      }
    },
    handleChangeScan(val) {
      if (val === 1) {
        this.$refs.goods0.focus();
      }
    },
  },
};
</script>
<style lang="less" >
.plan-add{
  .plan-table-index{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .plan-table{
    margin-top: 10px;
  }
  .orange-words{
    color: #FF4D07;
  }
  .approve-goods-wrap{
    display: flex;
    img{
      margin-right:4px;
    }
  }

  .expir-card{
    margin-top: 12px;
  }
  .goods-card{
    margin-top:12px;
    .ivu-card-body{
      position: relative;
    }
  }
  .sum-wrap{
    position: absolute;
    top: 8px;
    right: 0;
    width: 300px;
    height: 42px;
    left: auto;
    .title-amount{
      font-size: 12px;
      color: rgba(46,46,46,0.65);
      position: absolute;
      left: 0;
      top: 0;
      line-height: 18px;
    }
    .content-amount{
      font-size: 18px;
      color: rgba(46,46,46,0.85);
      bottom: 0;
      left: 0;
      position: absolute;
    }
    .title-money{
      font-size: 12px;
      color: rgba(46,46,46,0.65);
      position: absolute;
      top: 0;
      left: 150px;
      line-height: 18px;
    }
    .content-money{
      font-size: 18px;
      color: rgba(46,46,46,0.85);
      bottom: 0;
      left: 150px;
      position: absolute;
    }
  }
  .goods-add-wrap{
    display: flex;
    align-items: center;
    .goods-add-label {
      font-size:12px;
      height:17px;
      line-height:17px;
      font-weight:bold;
      margin-right:4px;
    }
  }
}
.attachment {
  .uploadNum {
    padding:0 10px 0 4px;
  }
  .uploadClick {
    cursor: pointer;
    font-weight: 500;
    color: #2d8cf0;
  }
}


</style>
